import type { FC } from 'react';
import type { TGlobalCompensationDetailsItemProps } from '@components/Organisms/GlobalCompensation/GlobalCompensation.types';
import { useTranslation } from 'react-i18next';
import { Icon } from '@reverse-hr/design-system';
import { DETAILS_ITEMS_TYPES_TO_ICONS_MAP } from '@components/Organisms/GlobalCompensation/_constants/bonuses-and-benefits.constants';
import { useStoreState } from 'easy-peasy';
import { jobActualStoreSelector } from '@model/Job/Job.selectors';
import { BENEFIT_TYPES } from '@model/Candidate/constants/types.constants';

export const GlobalCompensationDetailsItem: FC<
  TGlobalCompensationDetailsItemProps
> = ({ children, details, itemType, value }) => {
  const { t } = useTranslation('', {
    keyPrefix: 'globalCompensation.compensationPackage.details',
  });

  const { t: tCommon } = useTranslation('', { keyPrefix: 'common' });
  const jobState = useStoreState(jobActualStoreSelector);

  const currency = tCommon('currency', { context: jobState?.salaryCurrency });
  const iconName = DETAILS_ITEMS_TYPES_TO_ICONS_MAP[itemType];

  const isValueVisible =
    itemType !== BENEFIT_TYPES.DEVICES &&
    itemType !== BENEFIT_TYPES.REMOTE_WORKING;

  const displayedValue = tCommon('formatting.monetary', {
    value: value ?? '-',
    currency,
  });

  return (
    <li className="c-global-compensation-item">
      {iconName && (
        <Icon
          className="c-global-compensation-item__icon"
          name={iconName}
          size={16}
        />
      )}

      <div className="c-global-compensation-item__content">
        <div className="c-global-compensation-item__main-info">
          <p className="c-global-compensation-item__title">
            {t('item', { context: itemType })}
          </p>

          <p className="c-global-compensation-item__value">
            {isValueVisible ? displayedValue : null}
          </p>
        </div>

        {details && (
          <p className="c-global-compensation-item__details">{details}</p>
        )}

        {children}
      </div>
    </li>
  );
};
